<template>
    <div>
        <v-card raised class="mx-auto" max-width="650px">
            <v-img
                class="white--text align-end"
                height="150px"
                src="../../../assets/background/kings-logo-1.png"
                position="right 35% bottom 67%"
            >
                <v-card-title><v-btn outlined color="white" dark to="/jobpostings">View Job Postings</v-btn></v-card-title><br />
                <v-card-title class="text-h5">CUPE Application Portal</v-card-title>
            </v-img>
            <v-spacer></v-spacer>
            <v-card-text v-if="checkingloading">
                <v-container style="height: 450px;">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                        <v-col cols="6">
                            <v-progress-linear
                                color="#d7ae28"
                                indeterminate
                                rounded
                                height="6"
                            ></v-progress-linear>
                        </v-col>
                        <v-col class="text-subtitle-1 text-center" cols="12">
                            Preparing to launch...
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-text v-if="!checkingloading">
                <p>
                    If you have any concerns or issues, please contact King's HR via <a href="mailto:HR@kings.uwo.ca">HR@kings.uwo.ca</a> or call at 519-433-3491.
                </p>
                <p style="font-weight: bold" class="text-h6">Sign In</p>
                <form @submit.prevent="accountActiveCheck">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="user.email"
                                outlined
                                prepend-icon="mdi-email"
                                :rules="[rules.required, rules.email]"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="user.password"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required]"
                                :type="show1 ? 'text' : 'password'"
                                @click:append="show1 = !show1"
                                outlined
                                prepend-icon="mdi-key-variant"
                            ></v-text-field>
                        </v-col>
                        <v-row>
                            <v-col cols="3">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn to="/reverifyemail" color="white" outlined class="fb-fp-btn ma-3" v-bind="attrs" v-on="on">
                                            <span style="color:#6d6e71;">Verify Email</span>
                                        </v-btn>
                                    </template>
                                    <span>Verification Email didn't come during registration or the account not verified yet?</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="3">
                                <v-btn to="/forgetpassword" color="white" outlined class="fb-fp-btn ma-3" >
                                    <span style="color:#6d6e71;">Forgot Password?</span>
                                </v-btn>
                            </v-col>
                            <v-col  cols="3"></v-col>
                            <v-col  cols="3" class="d-flex justify-end mb-6">
                                <v-btn
                                    type="submit"
                                    class="ma-3"
                                    color="#004236"
                                    dark
                                    :loading="signinloading"
                                >
                                    Sign In
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-row>
                    <v-divider></v-divider>
                    <v-card-subtitle>No account yet?</v-card-subtitle>
                    <v-btn block to="/register" color="white" outlined class="fb-btn">
                        <span style="color: #004236;">register as an applicant</span>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-card-subtitle>Are you a King's admin member?</v-card-subtitle>
                    <v-btn block ref="staffBtn" @click="staffLogin()" :href="staffLink" color="#004236" dark>
                        Sign in as Admin
                    </v-btn>
                </form>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import firebase from 'firebase'
require('firebase/auth')

export default {
    data(){
        return {
            host: location.hostname.toString(),
            user: {
                email: "",
                password: ""
            },
            rules: {
                required: value => !!value || 'Required Field.',
                email: v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || "Invalid email format"
            },
            show1: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            staffLink: `https://${location.hostname}/cgi-bin/mkvn/app.pl?staff&redirect=1`,
            signinloading: false,
            checkingloading: true
        }
    },
    methods: {
        maintenanceCheck(){
            const that = this;
            that.checkingloading = true;
            const apimaintenance = `https://${location.hostname}/cgi-bin/cupe-app-api/api.py?`;

            fetch(apimaintenance)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if(json.hasOwnProperty("maintenance")){
                        if(json.maintenance.hasOwnProperty("group")){
                            if(json.maintenance.group != "none"){
                                that.$router.push('/undermaintenance');
                            }
                        }
                    }

                    that.checkingloading = false;
                })
                .catch(function (err) {
                    that.setSnackbar(err, "#E53935");
                    that.checkingloading = false;
                });
        },
        userLogin(status){
            this.signinloading = true;
            firebase
            .auth()
            .signInWithEmailAndPassword(this.user.email, this.user.password)
            .then((u) => {

                if(u.user.emailVerified){
                    this.signinloading = false;
                    var userInfo = {
                        name: u.user.displayName,
                        uid: u.user.uid,
                        email: u.user.email,
                        status: status
                    };
                    this.createSession(userInfo);
                    this.$router.push('/home')
                }else {
                    this.setSnackbar("Email Not Verified!", "#E53935");
                    this.signinloading = false;
                }
            })
            .catch((err) => {
                this.setSnackbar(err, "#E53935");
                this.signinloading = false;
            });
        },
        staffLogin() {
            this.$refs.staffBtn.loading = true;
        },
        createSession(u){
            let user = {
                "name": u.name,
                "email" : u.email,
                "uid" : u.uid,
                "department": "applicant",
                "status": u.status
            };
            // Create user session storage

            sessionStorage.setItem('user', JSON.stringify(user));
        },
        accountActiveCheck(){
            const that = this;
            const apiaccount = `https://${location.hostname}/cgi-bin/cupe-app-api/api.py?mode=accountactive&data={"email": "`+that.user.email+`"}`;
            that.signinloading = true;

            var status = "";

            fetch(apiaccount)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^ok/i)) {
                        if(json.active.toString() == "true"){
                            status = "true";
                        }else {
                            status = "false";
                        }
                    }else {
                        status = "false";
                    }
                    
                    that.userLogin(status);
                    that.signinloading = false;
                })
                .catch(function (err) {
                    that.setSnackbar(err, "#E53935");
                    that.signinloading = false;
                });
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.maintenanceCheck();
    }
}
</script>
<style scoped>
  .fb-btn.v-btn--outlined {
    border: thin solid #004236;
  }
  .fb-fp-btn.v-btn--outlined {
    border: thin solid #6d6e71;
  }
</style>